import React from 'react';
type SectionHeadingProps = {
  children: React.ReactNode;
  dark?: boolean;
  lead?: React.ReactNode;
  id?: string;
};
export function SectionHeading({
  children,
  dark = false,
  lead,
  id
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-64" data-mp="3f2dowwnbrpvv">
      <h2 id={id} className={`font-display text-[26px] font-black uppercase leading-[1.12] tracking-tight sm:text-4xl lg:text-[44px] ${dark ? 'text-white' : 'text-navy-900'}`} data-id="element-65" data-mp="3jzx4bzvre8pe">
        {children}
      </h2>
      {lead && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? 'text-white/80' : 'text-ink/70'}`} data-id="element-66" data-mp="glj99e7ip5r9">
          {lead}
        </p>}
    </div>;
}